import PropTypes from "prop-types";
import React, { createContext, useContext } from "react";
import { Card } from "@opendate-app/setlist";

const ClassicSectionContext = createContext(false);

export const SectionTitle = ({ title, locked, count, className }) => {
  const inSection = useContext(ClassicSectionContext);
  const lock = locked ? <i className="ml-2 far fa-lock small text-danger" title="Restricted by permissions"></i> : null;

  if (!inSection) {
    return <h5 className={className}>{title}{lock}</h5>;
  }

  return (
    <h5 className={`${className} classic-section__heading`}>
      {title}
      {count != null ? <span className="classic-section__count">{count}</span> : null}
      {lock}
    </h5>
  );
};

SectionTitle.propTypes = {
  title: PropTypes.node.isRequired,
  locked: PropTypes.bool,
  count: PropTypes.number,
  className: PropTypes.string,
};

SectionTitle.defaultProps = { locked: false, count: null, className: "strong" };

// The Setlist Card clips to its radius, which cut off the inline row menus (O-7163).
// Inline so it beats the styled-components class whichever CSS chunk loads.
const UNCLIPPED = { overflow: "visible" };

const ClassicSectionCard = ({ id, children }) => (
  <ClassicSectionContext.Provider value={true}>
    <section id={id} className="classic-section">
      <Card padding="none" style={UNCLIPPED}>{children}</Card>
    </section>
  </ClassicSectionContext.Provider>
);

ClassicSectionCard.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node,
};

ClassicSectionCard.defaultProps = { children: null };

export default ClassicSectionCard;
